/* eslint-disable no-plusplus */
import { useEffect, useState } from "react";

function useDynamicHeight(
  classNames = ["page-header", "page-footer", "add-scrollclass"]
) {
  const [dynamicHeight, setDynamicHeight] = useState("");

  useEffect(() => {
    const calculateHeight = () => {
      const totalHeight = classNames.reduce((acc, className) => {
        const elements = Array.from(document.querySelectorAll(`.${className}`));
        const height = elements.reduce(
          (innerAcc, element) => innerAcc + element.clientHeight,
          0
        );
        return acc + height;
      }, 0);
      setDynamicHeight(`calc(100vh - ${totalHeight + 115}px)`);
    };

    calculateHeight();

    window.addEventListener("resize", calculateHeight);
    return () => {
      window.removeEventListener("resize", calculateHeight);
    };
  }, [classNames]);

  return dynamicHeight;
}

export default useDynamicHeight;
